module.exports = __webpack_public_path__ + "static/img/application4-1.4f1cf80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-1.jpg
// module id = /Lcx
// module chunks = 0